<div class="container">
  <div class="how-to-play-container">
    <h3 class="title text-white text-uppercase">{{ 'fantasy.how.to.play.text' | translate }}</h3>

    <p class="mb-0 font-size-14 text-white">{{ 'fantasy.how.to.play.description' | translate }}</p>

    <div class="steps-container d-flex justify-content-between">
      <div class="step-item d-flex flex-column align-items-center justify-content-center bg-glass">
        <div class="icon-container d-flex align-items-center justify-content-center bg-glass">
          <span class="material-symbols-outlined"> account_circle </span>
        </div>

        <h4 class="step-title text-white text-uppercase">{{ 'fantasy.pick.your.player.text' | translate }}</h4>
        <p class="font-size-12 text-white text-center">{{ 'fantasy.pick.your.player.description' | translate }}</p>
      </div>

      <div class="step-item d-flex flex-column align-items-center justify-content-center bg-glass">
        <div class="icon-container d-flex align-items-center justify-content-center bg-glass">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>

        <h4 class="step-title text-white text-uppercase">{{ 'fantasy.earn.points.text' | translate }}</h4>
        <p class="font-size-12 text-white text-center">{{ 'fantasy.earn.points.description' | translate }}</p>
      </div>

      <div class="step-item d-flex flex-column align-items-center justify-content-center bg-glass">
        <div class="icon-container d-flex align-items-center justify-content-center bg-glass">
          <span class="material-symbols-outlined"> crown </span>
        </div>

        <h4 class="step-title text-white text-uppercase">{{ 'fantasy.climb.leaderboard.text' | translate }}</h4>
        <p class="font-size-12 text-white text-center">{{ 'fantasy.climb.leaderboard.description' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="scoring-points-container">
    <h3 class="title text-uppercase text-white">
      {{ 'fantasy.scoring.points.text' | translate }}
    </h3>

    <p class="mb-0 font-size-14 text-white">{{ 'fantasy.scoring.points.description' | translate }}</p>

    <div
      class="point-items d-flex flex-column text-white font-size-14"
      [innerHTML]="'fantasy.rules.points' | translate | markdownTranslate"
    ></div>
  </div>
</div>
